
    import {Component, Prop, Vue} from "vue-property-decorator";

    @Component
    export default class OkDialog extends Vue {
        @Prop({required: true})
        headline!: String;
        @Prop({required: true})
        text!: String;
    }
